<template>
    <div class="inventory-info">
        <b-row>
            <b-col>
                <b-button-group size="sm" class="w-100">
                    <b-button
                        variant="light"
                        class="px-0"
                        >
                        <small>
                            <strong>
                                新規
                                <br>
                                +
                            </strong>
                        </small>
                    </b-button>
                    <b-button
                        variant="success"
                        class="px-0"
                        >
                        <small>
                            <strong>
                                連携
                                <br>
                                102
                            </strong>
                        </small>
                    </b-button>
                    <b-button
                        variant="warning"
                        class="px-0"
                        @click="syncItemCaches"
                        :disabled="model.jobs['App\\Jobs\\Connector'+$_.capitalize(model.uuid)+'SyncItemCachesJob'] !== undefined"
                        >
                        <small>
                            <strong>
                                同期
                                <br>
                                <font-awesome-icon class="fa-fw" :class="{ 'fa-spin': model.jobs['App\\Jobs\\Connector'+$_.capitalize(model.uuid)+'SyncItemCachesJob'] !== undefined, }" icon="sync" />
                            </strong>
                        </small>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </div>
<!--
        <b-col cols="12" class="flex-grow-1 flex-shrink-0 text-nowrap py-1" v-if="auth_id == model.user_id || auth_level >= '300'">
            <b-button-group size="sm" class="w-100">
                <b-button
                    :variant="$store.getters['answer/status2variant'](item)"
                    class="px-0"
                    style="flex: 1"
                    v-for="item in [ 'pending', 'sent', 'paid', 'completed', 'canceling', 'canceled', ]"
                    :key="item"
                    @click="$router.push({ name: 'answers', params: { form_uuid: model.uuid, status: item, } })"
                    >
                    <small>
                        <strong>
                            {{ trans.labels['form_answers.status.' + item] }}
                            <br>
                            {{ model.count[item] | baseNumberFormatter }}
                        </strong>
                    </small>
                </b-button>
            </b-button-group>

            <div class="text-center mt-2">
                <small><router-link :to="{ name: 'answers', params: { form_uuid: model.uuid }}">すべて</router-link></small>
            </div>
        </b-col>
    </b-row>
-->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
        syncItemCaches () {
            this.$store
                .dispatch('inventory/sync_item_caches', this.model)
                .then((response) => {
                    this.$bus.$emit('grid-page:fetch-detail', response.data.data)
                })
                .catch((error) => {
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.inventory-info {
    button {
        line-height: 1;
    }
}
</style>

